module.exports = __webpack_public_path__ + "static/media/tab5.0e588737.svg";